<!-- 报修 -->
<template>
  <div class="body">
    <van-nav-bar
      title="燃气报修"
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="center">
      <div class="gas-account-div">
        <van-field
          v-model="gasAccount"
          center
          clearable
          label="燃气户号"
          placeholder="请输入燃气户号"
        ></van-field>
      </div>
      <div class="title">
        <img src="../../assets/bao-xiu/tz.png" alt="">
        <div class="font-text">
          如有漏气、爆炸、着火、人员伤亡、等紧急燃气事件，请立即拨打服务热线：
          <span>96777</span>
        </div>
      </div>
      <van-grid :column-num="3" :border="false">
        <van-grid-item :text="item.text" v-for="item in arr" :key="item.text" @click="checkUserGas(item.text)">
          <template #icon>
            <img :src="item.src" alt="" style="width: 90px;height: 90px">
          </template>
        </van-grid-item>
      </van-grid>
      <img src="../../assets/bao-xiu/call.png" alt="">
    </div>
  </div>
</template>

<script>
  import { getBjtongAccessToken, checkUserGas, operationRecords } from '../../api/accountInformation'
  import { passwordEncryption } from '../../utils/jsencrypt'
  import { getToken } from '../../api/login'

  export default {
    data () {
      return {
        arr: [
          {
            text: '管道阀门',
            src: require('../../assets/bao-xiu/gd.png')
          },
          {
            text: '燃气表',
            src: require('../../assets/bao-xiu/rqb.png')
          },
          {
            text: '燃气具',
            src: require('../../assets/bao-xiu/rqj.png')
          },
          {
            text: '燃气拆改',
            src: require('../../assets/bao-xiu/rqcg.png')
          },
          {
            text: '其他报修',
            src: require('../../assets/bao-xiu/other.png')
          },
          {
            text: '我的报修',
            src: require('../../assets/bao-xiu/my.png')
          }
        ],
        code: '', // 统一认证平台返回的code
        telephone: '', // 登录时的用户名
        password: '', // 登录密码
        gasAccount: '', // 燃气户号-查询条件
        gasAccountInfo: {}, // 户号信息
        state: '' // 区分H5和PC
      }
    },
    mounted () {
      this.code = this.$route.query.code
      console.log('统一认证平台返回的code为', this.code)
      this.state = this.$route.query.state
      if (this.state == 'PC') {
        window.location.href = 'https://zt.bjgas.com/resource/PC_AppH5_sit/#/pcGasRepair?code=' + this.code
      } else {
        this.getBjtongAccessToken(this.code)
      }
    },
    methods: {
      onClickLeft () {
        this.$router.go(-1)
      },

      // 校验户号并绑定
      checkUserGas (type) {
        const that = this
        if (that.gasAccount === '') {
          that.$toast.fail('请输入燃气户号')
          return
        }
        that.$toast.loading({
          message: '加载中...',
          forbidClick: true,
          duration: 0
        })
        const params = {
          userId: window.localStorage.userId,
          gasAccount: that.gasAccount
        }
        checkUserGas(params).then(res => {
          if (res.data.success) {
            that.$toast.clear()
            that.gasAccountInfo = res.data.rows[0]
            that.toReportRepair (type)
            that.operationRecords()
          } else {
            that.$toast.fail(res.data.message)
          }
        }).catch(() => {
        })
      },

      // 设备报修
      toReportRepair (type) {
        const that = this
        if (type == '我的报修') {
          // that.$router.push('/myRepair')
          that.$router.push({
            name: 'MyRepair',
            params: {
              gasAccountInfo: that.gasAccountInfo
            }
          })
        } else {
          that.$router.push({
            name: 'ReportRepair',
            params: {
              type: type,
              gasAccountInfo: that.gasAccountInfo
            }
          })
        }
      },

      // 获取登录人的信息，根据账号密码获得北燃的token
      getBjtongAccessToken (code) {
        const that = this
        that.$toast.loading({
          message: '加载中...',
          forbidClick: true,
          duration: 0
        })
        const params = {
          grantCode: code,
          operationType: '报修'
        }
        getBjtongAccessToken(params).then(res => {
          if (res.data.success) {
            that.telephone = res.data.rows[0].userName;
            that.password = res.data.rows[0].passwordEncrypted;
            window.localStorage.userId = res.data.rows[0].id;
            window.localStorage.userInfo = JSON.stringify(res.data.rows[0]);
            that.toAccountNumberManagement();
          } else {
            that.$toast.fail(res.data.message)
          }
        }).catch(() => {
        })
      },

      // 登录
      toAccountNumberManagement () {
        const that = this
        const params = {
          client_id: 'a8117f61-0643-43ba-a172-bca68f497051',
          client_secret: 'a376a615-1ba6-453f-8e30-f68ae0b1b3f9',
          grant_type: 'password',
          // username: passwordEncryption(that.telephone),
          username: that.telephone,
          // password: passwordEncryption(that.password)
          // password: passwordEncryption('Bjtong')
          password: 'Bjtong'
        }
        getToken(params).then(res => {
          that.onLogin(res.data)
        }).catch(() => {
          this.$toast.fail('用户名或密码错误')
        })
      },

      // 获取token成功
      onLogin (resp) {
        window.localStorage.smartHistory = ''
        if (resp.access_token) {
          window.localStorage.tokenType = resp.token_type
          window.localStorage.token = resp.access_token
          this.$toast.clear();
        } else {
          this.$toast.fail('获取token失败')
        }
      },

      // 记录用户操作类型
      operationRecords () {
        const that = this
        const params = {
          userId: window.localStorage.userId,
          gasAccount: that.gasAccount,
          operationType: '报修'
        }
        operationRecords(params).then(res => {
          if (res.data.success) {
          } else {
            that.$toast.fail(res.data.message)
          }
        }).catch(() => {
        })
      }
    }
  }
</script>

<style scoped>
  .body {
    width: 100%;
    height: 100%;
  }

  .center {
    height: calc(100% - 45px);
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
  }

  .title {
    display: flex;
  }

  .font-text {
    font-size: 12px;
    color: #DB0000;
  }

  .title img {
    width: 22px;
    height: 22px;
    margin-right: 5px;
  }

  .font-text span {
    color: #333;
  }

  .center > img {
    position: absolute;
    bottom: 40px;
    width: 60%;
    margin-left: 15%;
  }

  .gas-account-div {
    margin-bottom: 10px;
  }
</style>
